/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import { QueryCache } from '@tanstack/react-query';
import { errorSignal } from '../../Signals/errorSignal';

export const reactQueryConfig = {
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 1000 * 300, // 300 seconds
      cacheTime: 1000 * 300, // 300 seconds
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      // refetchInterval: 1000 * 30, //30 seconds
      refetchIntervalInBackground: false,
      suspense: false,
    },
    mutations: {
      retry: 0,
    },
    queryCache: new QueryCache({
      onError: (error) => {
        errorSignal.signal.value = error;
      },
    }),
  },
};

// cacheTime vs. staleTime
// https://github.com/tannerlinsley/react-query/discussions/1685
